import React, { useContext, useEffect } from "react";
import WebtopLayoutContext from "../layout/WebtopLayoutContext";
import {
  WALLPAPERS,
  ACCENTS,
  THEMES,
  getTheme,
  getAccent,
  getWallpaperId,
} from "../layout/layoutModel";

/**
 * PersonalizePanel — appearance settings (wallpaper, theme, accent). Each change
 * updates the layout (debounced autosave) and is applied live by WebtopPreview.
 */
const PersonalizePanel = ({ onClose }) => {
  const { layout, updateLayout } = useContext(WebtopLayoutContext);

  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && onClose();
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [onClose]);

  const theme = getTheme(layout);
  const accent = getAccent(layout);
  const wallpaperId = getWallpaperId(layout);

  return (
    <div className="webtop-personalize-backdrop" onMouseDown={onClose}>
      <div
        className="webtop-personalize"
        role="dialog"
        aria-label="Personalize"
        onMouseDown={(e) => e.stopPropagation()}
      >
        <div className="webtop-personalize__head">
          <span>Personalize</span>
          <button type="button" aria-label="Close" className="webtop-personalize__close" onClick={onClose}>
            ✕
          </button>
        </div>

        <div className="webtop-personalize__section">
          <div className="webtop-personalize__label">Wallpaper</div>
          <div className="webtop-personalize__wallpapers">
            {Object.entries(WALLPAPERS).map(([id, css]) => (
              <button
                key={id}
                type="button"
                aria-label={`Wallpaper ${id}`}
                className={`webtop-wallpaper${id === wallpaperId ? " webtop-wallpaper--sel" : ""}`}
                style={{ background: css }}
                onClick={() => updateLayout({ wallpaper: id })}
              />
            ))}
          </div>
        </div>

        <div className="webtop-personalize__section">
          <div className="webtop-personalize__label">Theme</div>
          <div className="webtop-personalize__themes">
            {THEMES.map((t) => (
              <button
                key={t}
                type="button"
                className={`webtop-themebtn${t === theme ? " webtop-themebtn--sel" : ""}`}
                onClick={() => updateLayout({ theme: t })}
              >
                {t[0].toUpperCase() + t.slice(1)}
              </button>
            ))}
          </div>
        </div>

        <div className="webtop-personalize__section">
          <div className="webtop-personalize__label">Accent color</div>
          <div className="webtop-personalize__accents">
            {ACCENTS.map((c) => (
              <button
                key={c}
                type="button"
                aria-label={`Accent ${c}`}
                className={`webtop-accent${c === accent ? " webtop-accent--sel" : ""}`}
                style={{ background: c }}
                onClick={() => updateLayout({ accent: c })}
              />
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default PersonalizePanel;
